@if (shouldCoordsShow) {
  <div id="coordsContainer" [class.coordsContainerNoAttributes]="applicationSettings.option?.map?.disableAttributions">
    <button id="coordsBtn" (click)="flipState()" [matTooltip]="selText.coordinates" matTooltipClass="tooltipStyle">
      <mat-icon id="coordsIcon">gps_not_fixed </mat-icon>
    </button>
    <div id="coordsBoxes">
      @if (state === 'open') {
        <div
          id="latLongCoordinatesInfo"
          matTooltip="{{ selText.latLong }} {{ selText.coordinates }} {{ coordinateConfig.gpsFormat }}"
          matTooltipClass="tooltipStyle"
          matTooltipPosition="left"
          (click)="coordsToClipboard(latLongCoordinatesValue)"
          >
          <!-- title = "Latitude/longitude Coordinates" -->
          <p>{{ latLongCoordinatesValue }}</p>
        </div>
      }
      @if (state === 'open') {
        <div
          id="EPSGCoordinatesInfo"
          matTooltip="{{ coordinateConfig.name }} {{ selText.coordinates }}"
          matTooltipClass="tooltipStyle"
          matTooltipPosition="left"
          (click)="coordsToClipboard(displayedCoordinatesValue)"
          >
          <p>{{ coordinateConfig.name }}: {{ displayedCoordinatesValue?.join(', ') }}</p>
        </div>
      }
    </div>
  </div>
}